<div class="sip-impact-wrapper">
  <div class="header">
    <div class="title">
      Our Impact
    </div>
    <div class="hr-yellow my-4"></div>
    <div class="sub-title">
      {{ isMobile? info.subTitle.mobile.msg:info.subTitle.desktop.msg }}
      <span>
        {{ isMobile? info.subTitle.mobile.by:info.subTitle.desktop.by }}
      </span>
    </div>
  </div>

  <div class="map-wrapper container">
    <div class="row">
      <div class="col-lg-6 col-md-12 col-sm-12">
        <div class="map">
          <img class="main-img" data-src="assets/images/sip/background/india-2.png" loading="lazy" alt="no image">
          <div [class]="'location-pin-group-' + (i+1) + (location.isSelected? '-scaled':'')" *ngFor="let location of locationProfileInfo;index as i" (click)="selectLocationPin(i)">
            <span class="location-pin">
              <img [ngClass]="location.isSelected ? 'selected': ''" data-src="{{ 'assets/images/sip/icons/location-pin-' +(!location.isSelected ? 'un': '')+  'selected.png' }}" loading="lazy" alt="no image" />
              <span class="profile-image">
                <img [ngClass]="location.isSelected ? 'selected': ''" data-src="{{ 'assets/images/sip/map/'+ location.name + (location.isSelected ? '-scaled': '') +'.png' }}" loading="lazy" alt="no image">
              </span>
              <span class="text" *ngIf="location.isSelected">
                {{ location.desc }}
              </span>
            </span>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-12 col-sm-12">
        <div class="contribution-wrapper">
          <div class="card" *ngFor="let item of contributionInfo">
            <div class="img">
              <img data-src="{{ 'assets/images/sip/icons/' + item.imgName + '.png'}}" loading="lazy" alt="no image" class="pin-img">
            </div>
            <div class="number">
              {{ item.number }}
            </div>
            <div class="text">
              {{ item.text }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
